import _extends from '@babel/runtime-corejs3/helpers/extends';
import React__default from 'react';
import classNames from 'classnames';
import styles from './LoadingSpinner2.js';
import '../../utils/Translation/index.js';
import useTranslation from '../../utils/Translation/useTranslation.js';

const LoadingSpinner = /*#__PURE__*/React__default.forwardRef((_ref, ref) => {
  let {
    background = 'fade',
    children,
    className,
    inverted = false,
    show = false,
    size = 'medium',
    role = 'progressbar',
    'aria-label': ariaLabel,
    'aria-labelledby': ariaLabelledby,
    'aria-live': ariaLive = 'polite',
    'aria-hidden': ariaHidden,
    ...rest
  } = _ref;
  const {
    translate
  } = useTranslation();
  const defaultAriaLabel = translate('loading');
  return /*#__PURE__*/React__default.createElement("div", _extends({}, rest, {
    ref: ref,
    className: classNames(className, styles.spinnerContainer, {
      [styles[size]]: !children
    })
  }), /*#__PURE__*/React__default.createElement("div", {
    className: classNames(styles.spinnerComponent, styles[size], {
      [styles.inverted]: inverted,
      [styles.hide]: !show
    }),
    "data-loadingspinner": show || undefined,
    role: role,
    "aria-label": ariaLabel !== null && ariaLabel !== void 0 ? ariaLabel : ariaLabelledby ? undefined : defaultAriaLabel,
    "aria-labelledby": ariaLabelledby,
    "aria-live": ariaLive,
    "aria-hidden": ariaHidden
  }, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("div", null), /*#__PURE__*/React__default.createElement("div", null), /*#__PURE__*/React__default.createElement("div", null), /*#__PURE__*/React__default.createElement("div", null), /*#__PURE__*/React__default.createElement("div", null), /*#__PURE__*/React__default.createElement("div", null), /*#__PURE__*/React__default.createElement("div", null), /*#__PURE__*/React__default.createElement("div", null), /*#__PURE__*/React__default.createElement("div", null))), /*#__PURE__*/React__default.createElement("div", {
    className: classNames(styles.spinnerContent, {
      [styles[background]]: show,
      [styles.disablePointerEvents]: show
    })
  }, children));
});

export { LoadingSpinner as default };
